/** Shared section title styling for My List / My Leagues / My Points. */
export const PROFILE_SECTION_HEADING_PROPS = {
  fontSize: 'lg',
  lineHeight: 'short',
} as const;

/** Inner stack spacing below section titles (matches mobile card bodies). */
export const PROFILE_SECTION_BODY_SPACING = 3;

/** Symmetric horizontal inset for Results/Fixtures tab list content (match rows + matchday headers). */
export const MATCH_FEED_LIST_PAD_X = 0;

/** Footer CTAs on My Leagues — matches default Chakra md Button. */
export const PROFILE_SECTION_FOOTER_BUTTON_PROPS = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
} as const;
